module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "data-v-4bae0610": "",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "data-v-4bae0610": ""
    }
  }, [_c('path', {
    attrs: {
      "data-v-4bae0610": "",
      "d": "M437,331a255,255,0,0,0-97.28-61A148,148,0,0,0,404,148C404,66.39,337.61,0,256,0S108,66.39,108,148a148,148,0,0,0,64.26,122A256.4,256.4,0,0,0,0,512H40c0-119.1,96.9-216,216-216s216,96.9,216,216h40a254.33,254.33,0,0,0-75-181M256,256A108,108,0,1,1,364,148,108.12,108.12,0,0,1,256,256"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bac4f1d","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/profile.vue
// module id = 073e6eef5eec1a36947f
// module chunks = 89